import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2FilterOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" data-name="Artwork" viewBox="0 0 32 32" width="1em" height="1em"><path d="M4 11h.03L12 17.476V28h6.6l1.4-2h-6v-9.476L7.2 11h17.6L18 16.524V24h2v-6.524L27.97 11H28V4H4zm2-5h20v3H6z" /></svg>
);
